import React, { useState, useEffect } from 'react';
import { getOrderHistory } from '../services/api';
import './OrderHistory.css';

function OrderHistory({ orderId, isOpen, onClose }) {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && orderId) {
      loadHistory();
    }
  }, [isOpen, orderId]);

  const loadHistory = async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await getOrderHistory(orderId);
      if (result.success) {
        setHistory(result.history || []);
      } else {
        setError(result.message || 'Erreur lors du chargement de l\'historique');
      }
    } catch (err) {
      setError('Erreur lors du chargement de l\'historique');
    } finally {
      setLoading(false);
    }
  };

  const fieldLabels = {
    customerName: 'Nom du client',
    pickupLocation: 'Lieu de retrait',
    pickupDate: 'Date de retrait',
    pickupTime: 'Heure de retrait',
    orderComment: 'Commentaire',
    items: 'Articles commandés'
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('fr-FR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatValue = (value, fieldName) => {
    if (!value) return '(vide)';

    if (fieldName === 'items') {
      try {
        const items = typeof value === 'string' ? JSON.parse(value) : value;
        return Array.isArray(items)
          ? items.map(item => `${item.name} (${item.quantity})`).join(', ')
          : '(vide)';
      } catch (e) {
        return value;
      }
    }

    return value;
  };

  if (!isOpen) return null;

  return (
    <div className="order-history-modal-overlay">
      <div className="order-history-modal-content">
        <div className="modal-header">
          <h2>Historique des modifications</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          {error && <div className="modal-error">{error}</div>}

          {loading ? (
            <div className="loading">Chargement...</div>
          ) : history.length === 0 ? (
            <div className="no-history">
              <p>Aucune modification enregistrée</p>
            </div>
          ) : (
            <div className="history-timeline">
              {history.map((entry, index) => (
                <div key={index} className="history-entry">
                  <div className="history-entry-header">
                    <span className="history-field">
                      {fieldLabels[entry.fieldName] || entry.fieldName}
                    </span>
                    <span className="history-info">
                      <span className="history-user">{entry.modifiedBy}</span>
                      <span className="history-time">
                        {formatDate(entry.modifiedAt)}
                      </span>
                    </span>
                  </div>

                  <div className="history-values">
                    <div className="old-value">
                      <span className="label">Avant:</span>
                      <span className="value">{formatValue(entry.oldValue, entry.fieldName)}</span>
                    </div>
                    <div className="arrow">→</div>
                    <div className="new-value">
                      <span className="label">Après:</span>
                      <span className="value">{formatValue(entry.newValue, entry.fieldName)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="close-button">
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}

export default OrderHistory;
